import React, { useState, useEffect, useRef } from 'react';
import { ALERT_TYPE, PATTERNS, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject, GetMeses} from '../../../utils/helpers';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {isEmptyString, isValidNumber} from '../../../utils/validator';
import DireccionForm from '../DireccionForm';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import {TIPS} from "../../../consts/tips";
import { FetchCartelDefinicion } from './utils';

import { useFormErrors } from '../../hooks/useFormErrors';
import { Accordion, DatePickerCustom, FormError, FormLabel, InputCuenta, InputEjercicio, InputEntidad, InputLista, InputNumber, InputSubTasa, InputTasa, Loading, Modal, Select } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const CartelModal = (props) => {

    const direccionInit = {
        id: 0,
        entidad: "Cartel",
        idEntidad: 0,
        idTipoGeoreferencia: 0,
        idPais: 0,
        idProvincia: 0,
        idLocalidad: 0,
        idZonaGeoreferencia: 0,
        codigoPostal: "",
        calle: "",
        entreCalle1: "",
        entreCalle2: "",
        altura: "",
        piso: "",
        dpto: "",
        referencia: "",
        longitud: 0,
        latitud: 0,
        origen: ""
    }
    const entityInit = {
        id: 0,
        idComercio: 0,
        numero: 0,
        idTipoProductoPublicitado: 0,
        idTipoAnuncio: 0,
        idTipoCartel: 0,
        idTipoPropiedad: 0,
        idOrigenDeclaracionJurada: 0,
        idCategoriaUbicacion: 0,
        anuncio: '',
        marquesina: 0,
        cantidadPublicidades: 0,
        fechaInicio: null,
        fechaResolucion: null,
        numeroDDJJ: '',
        fechaDDJJ: null,
        anioDDJJ: '',
        mesDDJJ: 0,
        catastralCir: '',
        catastralSec: '',
        catastralCod: '',
        catastralChacra: '',
        catastralLchacra: '',
        catastralQuinta: '',
        catastralLquinta: '',
        catastralFrac: '',
        catastralLfrac: '',
        catastralManz: '',
        catastralLmanz: '',
        catastralParc: '',
        catastralLparc: '',
        catastralSubparc: '',
        catastralUfunc: '',
        catastralUcomp: '',
        idCuentaInmueble: 0,
        idTasa: 0,
        idSubTasa: 0,
        alto: 0,
        ancho: 0,
        superficie: 0,
        idMotivoBajaComercio: 0,
        fechaBaja: null,
        idBloqueoEmision: 0,
        direccion: direccionInit
    };
    const cartelDefinicionInit = {
        tipoProductoPublicitadoObligatorio: false,
        tipoCartelObligatorio: false,
        tipoAnuncioObligatorio: false,
        tipoPropiedadObligatorio: false,
        categoriaUbicacionObligatorio: false,
        marquesinaObligatorio: false,
        cantidadPublicidadesObligatorio: false,
        anuncioObligatorio: false,
        fechaInicioObligatorio: false,
        tasaObligatorio: false,
        fechaResolucionObligatorio: false,
        altoAnchoObligatorio: false,
        superficieObligatorio: false,
        catastralObligatorio: false,
        direccionObligatorio: false,
        declaracionJuradaObligatorio: false
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });
    const [loading, setLoading] = useState(false);
    const [direccionOpen, setDireccionOpen] = useState(false);
    const [datosOpen, setDatosOpen] = useState(true);
    const [catastralOpen, setCatastralOpen] = useState(false);
    const [declaracionJuradaOpen, setDeclaracionJuradaOpen] = useState(false);
    const [cartelDefinicion, setCartelDefinicion] = useState(cartelDefinicionInit);
    //en un cartel nuevo, la unica opcion se preselecciona hasta que el campo cambia: si el operador la borra, queda vacio
    const [autoSelect, setAutoSelect] = useState({
        idTipoAnuncio: props.data.entity.id <= 0,
        idCategoriaUbicacion: props.data.entity.id <= 0
    });

    useEffect(() => {
        let isCurrent = true;
        FetchCartelDefinicion()
            .then(def => { if (isCurrent) setCartelDefinicion(def); })
            .catch(() => {});
        return () => { isCurrent = false; };
    }, []);

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            id: props.data.entity.id,
            idComercio: props.data.entity.idComercio,
            numero: parseInt(props.data.entity.numero),
            idTipoProductoPublicitado: props.data.entity.idTipoProductoPublicitado,
            idTipoAnuncio: props.data.entity.idTipoAnuncio,
            idTipoCartel: props.data.entity.idTipoCartel,
            idTipoPropiedad: props.data.entity.idTipoPropiedad,
            idOrigenDeclaracionJurada: props.data.entity.idOrigenDeclaracionJurada,
            idCategoriaUbicacion: props.data.entity.idCategoriaUbicacion,
            anuncio: props.data.entity.anuncio,
            marquesina: parseInt(props.data.entity.marquesina),
            cantidadPublicidades: parseInt(props.data.entity.cantidadPublicidades),
            fechaInicio: props.data.entity.fechaInicio,
            fechaResolucion: props.data.entity.fechaResolucion,
            numeroDDJJ: props.data.entity.numeroDDJJ,
            fechaDDJJ: props.data.entity.fechaDDJJ,
            anioDDJJ: props.data.entity.anioDDJJ,
            mesDDJJ: parseInt(props.data.entity.mesDDJJ),
            catastralCir: props.data.entity.catastralCir,
            catastralSec: props.data.entity.catastralSec,
            catastralCod: props.data.entity.catastralCod,
            catastralChacra: props.data.entity.catastralChacra,
            catastralLchacra: props.data.entity.catastralLchacra,
            catastralQuinta: props.data.entity.catastralQuinta,
            catastralLquinta: props.data.entity.catastralLquinta,
            catastralFrac: props.data.entity.catastralFrac,
            catastralLfrac: props.data.entity.catastralLfrac,
            catastralManz: props.data.entity.catastralManz,
            catastralLmanz: props.data.entity.catastralLmanz,
            catastralParc: props.data.entity.catastralParc,
            catastralLparc: props.data.entity.catastralLparc,
            catastralSubparc: props.data.entity.catastralSubparc,
            catastralUfunc: props.data.entity.catastralUfunc,
            catastralUcomp: props.data.entity.catastralUcomp,
            idCuentaInmueble: props.data.entity.idCuentaInmueble,
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            alto: parseFloat(props.data.entity.alto),
            ancho: parseFloat(props.data.entity.ancho),
            superficie: parseFloat(props.data.entity.superficie),
            idMotivoBajaComercio: props.data.entity.idMotivoBajaComercio,
            fechaBaja: props.data.entity.fechaBaja,
            idBloqueoEmision: props.data.entity.idBloqueoEmision
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        numero: 0,
        idTipoProductoPublicitado: 0,
        idTipoAnuncio: 0,
        idTipoCartel: 0,
        idTipoPropiedad: 0,
        idOrigenDeclaracionJurada: 0,
        idCategoriaUbicacion: 0,
        anuncio: '',
        marquesina: 0,
        cantidadPublicidades: 0,
        fechaInicio: null,
        fechaResolucion: null,
        numeroDDJJ: '',
        fechaDDJJ: null,
        anioDDJJ: '',
        mesDDJJ: 0,
        catastralCir: '',
        catastralSec: '',
        catastralCod: '',
        catastralChacra: '',
        catastralLchacra: '',
        catastralQuinta: '',
        catastralLquinta: '',
        catastralFrac: '',
        catastralLfrac: '',
        catastralManz: '',
        catastralLmanz: '',
        catastralParc: '',
        catastralLparc: '',
        catastralSubparc: '',
        catastralUfunc: '',
        catastralUcomp: '',
        idCuentaInmueble: 0,
        idTasa: 0,
        idSubTasa: 0,
        alto: 0,
        ancho: 0,
        superficie: 0,
        idMotivoBajaComercio: 0,
        fechaBaja: null,
        idBloqueoEmision: 0
    });

    const direccionFormRef = useRef();

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleChangeAutoSelect = (event) => {
        setAutoSelect(prevState => ({...prevState, [event.target.name]: false}));
        formHandle(event);
    };

    const handleClickAceptar = () => {
        if (isFormValid()) {
            let row = CloneObject(state.entity);
            row.numero = formValues.numero;
            row.idTipoProductoPublicitado = !isEmptyString(formValues.idTipoProductoPublicitado) ? parseInt(formValues.idTipoProductoPublicitado) : 0;
            row.idTipoAnuncio = !isEmptyString(formValues.idTipoAnuncio) ? parseInt(formValues.idTipoAnuncio) : 0;
            row.idTipoCartel = !isEmptyString(formValues.idTipoCartel) ? parseInt(formValues.idTipoCartel) : 0;
            row.idTipoPropiedad = !isEmptyString(formValues.idTipoPropiedad) ? parseInt(formValues.idTipoPropiedad) : 0;
            row.idOrigenDeclaracionJurada = !isEmptyString(formValues.idOrigenDeclaracionJurada) ? parseInt(formValues.idOrigenDeclaracionJurada) : 0;
            row.idCategoriaUbicacion = !isEmptyString(formValues.idCategoriaUbicacion) ? parseInt(formValues.idCategoriaUbicacion) : 0;
            row.anuncio = formValues.anuncio;
            row.marquesina = formValues.marquesina;
            row.cantidadPublicidades = formValues.cantidadPublicidades;
            row.fechaInicio = formValues.fechaInicio;
            row.fechaResolucion = formValues.fechaResolucion;
            row.numeroDDJJ = formValues.numeroDDJJ;
            row.fechaDDJJ = formValues.fechaDDJJ;
            row.anioDDJJ = formValues.anioDDJJ;
            row.mesDDJJ = formValues.mesDDJJ;
            row.catastralCir = formValues.catastralCir;
            row.catastralSec = formValues.catastralSec;
            row.catastralCod = formValues.catastralCod;
            row.catastralChacra = formValues.catastralChacra;
            row.catastralLchacra = formValues.catastralLchacra;
            row.catastralQuinta = formValues.catastralQuinta;
            row.catastralLquinta = formValues.catastralLquinta;
            row.catastralFrac = formValues.catastralFrac;
            row.catastralLfrac = formValues.catastralLfrac;
            row.catastralManz = formValues.catastralManz;
            row.catastralLmanz = formValues.catastralLmanz;
            row.catastralParc = formValues.catastralParc;
            row.catastralLparc = formValues.catastralLparc;
            row.catastralSubparc = formValues.catastralSubparc;
            row.catastralUfunc = formValues.catastralUfunc;
            row.catastralUcomp = formValues.catastralUcomp;
            row.idCuentaInmueble = formValues.idCuentaInmueble;
            row.idTasa = !isEmptyString(formValues.idTasa) ? parseInt(formValues.idTasa) : 0;
            row.idSubTasa = !isEmptyString(formValues.idSubTasa) ? parseInt(formValues.idSubTasa) : 0;
            row.alto = formValues.alto;
            row.ancho = formValues.ancho;
            row.superficie = formValues.superficie;
            row.idMotivoBajaComercio = !isEmptyString(formValues.idMotivoBajaComercio) ? parseInt(formValues.idMotivoBajaComercio) : 0;
            row.fechaBaja = formValues.fechaBaja;
            row.idBloqueoEmision = !isEmptyString(formValues.idBloqueoEmision) ? parseInt(formValues.idBloqueoEmision) : 0;

            row.direccion = direccionFormRef.current.getDataDireccion()

            props.onConfirm(row);
        }
        ;
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (!isValidNumber(formValues.numero, true)) errors.numero = 'Ingresá un número mayor a cero';
        if (cartelDefinicion.fechaInicioObligatorio && formValues.fechaInicio == null) errors.fechaInicio = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (cartelDefinicion.tipoProductoPublicitadoObligatorio && formValues.idTipoProductoPublicitado <= 0) errors.idTipoProductoPublicitado = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.tipoAnuncioObligatorio && formValues.idTipoAnuncio <= 0) errors.idTipoAnuncio = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.tipoCartelObligatorio && formValues.idTipoCartel <= 0) errors.idTipoCartel = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.superficieObligatorio && formValues.superficie <= 0) errors.superficie = 'Ingresá un número mayor a cero';
        if (cartelDefinicion.tipoPropiedadObligatorio && formValues.idTipoPropiedad <= 0) errors.idTipoPropiedad = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.categoriaUbicacionObligatorio && formValues.idCategoriaUbicacion <= 0) errors.idCategoriaUbicacion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.marquesinaObligatorio && formValues.marquesina <= 0) errors.marquesina = 'Ingresá un número mayor a cero';
        if (cartelDefinicion.cantidadPublicidadesObligatorio && formValues.cantidadPublicidades <= 0) errors.cantidadPublicidades = 'Ingresá un número mayor a cero';
        if (cartelDefinicion.anuncioObligatorio && formValues.anuncio.length <= 0) errors.anuncio = VALIDATION_MESSAGE.REQUIRED;
        if (cartelDefinicion.fechaResolucionObligatorio && formValues.fechaResolucion == null) errors.fechaResolucion = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (cartelDefinicion.tasaObligatorio && formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.tasaObligatorio && formValues.idSubTasa <= 0) errors.idSubTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.altoAnchoObligatorio && formValues.alto <= 0) errors.alto = 'Ingresá un número mayor a cero';
        if (cartelDefinicion.altoAnchoObligatorio && formValues.ancho <= 0) errors.ancho = 'Ingresá un número mayor a cero';
        if (cartelDefinicion.catastralObligatorio && !(formValues.idCuentaInmueble > 0) && ![
            formValues.catastralCir, formValues.catastralSec, formValues.catastralCod, formValues.catastralChacra,
            formValues.catastralLchacra, formValues.catastralQuinta, formValues.catastralLquinta, formValues.catastralFrac,
            formValues.catastralLfrac, formValues.catastralManz, formValues.catastralLmanz, formValues.catastralParc,
            formValues.catastralLparc, formValues.catastralSubparc, formValues.catastralUfunc, formValues.catastralUcomp
        ].some(x => x?.length > 0 && !/^0+$/.test(x))) errors.idCuentaInmueble = 'Vinculá un inmueble o completá algún dato de la nomenclatura';
        if (cartelDefinicion.declaracionJuradaObligatorio && formValues.idOrigenDeclaracionJurada <= 0) errors.idOrigenDeclaracionJurada = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (cartelDefinicion.declaracionJuradaObligatorio && formValues.numeroDDJJ.length <= 0) errors.numeroDDJJ = VALIDATION_MESSAGE.REQUIRED;
        if (cartelDefinicion.declaracionJuradaObligatorio && formValues.fechaDDJJ == null) errors.fechaDDJJ = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (cartelDefinicion.declaracionJuradaObligatorio && formValues.anioDDJJ.length <= 0) errors.anioDDJJ = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (cartelDefinicion.declaracionJuradaObligatorio && formValues.mesDDJJ <= 0) errors.mesDDJJ = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    function isFormValid() {

        if (!validate()) {
            const errors = getErrors();
            setDatosOpen(true);
            if (errors.idCuentaInmueble) setCatastralOpen(true);
            if (errors.idOrigenDeclaracionJurada || errors.numeroDDJJ || errors.fechaDDJJ || errors.anioDDJJ || errors.mesDDJJ) setDeclaracionJuradaOpen(true);
            return false;
        }

        const data = direccionFormRef.current.getDataDireccion()
        if (cartelDefinicion.direccionObligatorio || data.altura || data.calle || data.codigoPostal || data.dpto || data.entreCalle1 ||
            data.entreCalle2 || data.idPais || data.idProvincia || data.piso) {
            const isValidDireccion = direccionFormRef.current.isValidDireccion()
            if (!isValidDireccion.result) {
                setDireccionOpen(true);
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, isValidDireccion.message);
                return false;
            }
        }

        return true;
    }

    function SetInmuebleData(idInmueble) {
        FindInmueble(idInmueble);
    }

    function ClearInmuebleData() {
        formSet({
            ...formValues,
            idCuentaInmueble: null,
            catastralCir: state.entity.catastralCir,
            catastralSec: state.entity.catastralSec,
            catastralCod: state.entity.catastralCod,
            catastralChacra: state.entity.catastralChacra,
            catastralLchacra: state.entity.catastralLchacra,
            catastralQuinta: state.entity.catastralQuinta,
            catastralLquinta: state.entity.catastralLquinta,
            catastralFrac: state.entity.catastralFrac,
            catastralLfrac: state.entity.catastralLfrac,
            catastralManz: state.entity.catastralManz,
            catastralLmanz: state.entity.catastralLmanz,
            catastralParc: state.entity.catastralParc,
            catastralLparc: state.entity.catastralLparc,
            catastralSubparc: state.entity.catastralSubparc,
            catastralUfunc: state.entity.catastralUfunc,
            catastralUcomp: state.entity.catastralUcomp
        });
    }

    function FindInmueble(idInmueble) {

        const callbackNoSuccess = (response) => {
            response.json()
                .then((error) => {
                    const message = error.message;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setLoading(false);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setLoading(false);
                });
        }
        const callbackError = (error) => {
            const message = 'Error procesando solicitud: ' + error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        }
        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {
                    formSet({
                        ...formValues,
                        idCuentaInmueble: data.inmueble.idCuenta,
                        catastralCir: data.inmueble.catastralCir,
                        catastralSec: data.inmueble.catastralSec,
                        catastralCod: data.inmueble.catastralCod,
                        catastralChacra: data.inmueble.catastralChacra,
                        catastralLchacra: data.inmueble.catastralLchacra,
                        catastralQuinta: data.inmueble.catastralQuinta,
                        catastralLquinta: data.inmueble.catastralLquinta,
                        catastralFrac: data.inmueble.catastralFrac,
                        catastralLfrac: data.inmueble.catastralLfrac,
                        catastralManz: data.inmueble.catastralManz,
                        catastralLmanz: data.inmueble.catastralLmanz,
                        catastralParc: data.inmueble.catastralParc,
                        catastralLparc: data.inmueble.catastralLparc,
                        catastralSubparc: data.inmueble.catastralSubparc,
                        catastralUfunc: data.inmueble.catastralUfunc,
                        catastralUcomp: data.inmueble.catastralUcomp
                    });
                    setLoading(false);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setLoading(false);
                });
        };

        setLoading(true);

        const paramsUrl = `/${idInmueble}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.INMUEBLE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <>

            <Loading visible={loading}></Loading>

            <Modal
                size="xl"
                title={`Cartel: ${(state.entity.id > 0) ? state.entity.numero : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.CARTEL_MODAL}
                onEscape={() => props.onDismiss()}
                body={(<>
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Datos del cartel" open={datosOpen} onToggle={setDatosOpen}>
                                        <div className='row form-basic'>

                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="numero" required>Número</FormLabel>
                                                <InputNumber
                                                    name="numero"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                                                    value={formValues.numero}
                                                    onChange={formHandle}
                                                    precision={0}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('numero')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="idTipoProductoPublicitado" required={cartelDefinicion.tipoProductoPublicitadoObligatorio}>Tipo
                                                    producto publicitado</FormLabel>
                                                <InputLista
                                                    name="idTipoProductoPublicitado"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoProductoPublicitado') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoProductoPublicitado}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoProductoPublicitado"
                                                    showGrid={true}
                                                />
                                                <FormError message={errorOf('idTipoProductoPublicitado')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="idTipoCartel" required={cartelDefinicion.tipoCartelObligatorio}>Tipo
                                                    cartel</FormLabel>
                                                <InputLista
                                                    name="idTipoCartel"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoCartel') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoCartel}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoCartel"
                                                    showGrid={true}
                                                />
                                                <FormError message={errorOf('idTipoCartel')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="idTipoAnuncio" required={cartelDefinicion.tipoAnuncioObligatorio}>Tipo
                                                    anuncio</FormLabel>
                                                <InputEntidad
                                                    name="idTipoAnuncio"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.TIPO_ANUNCIO_MODAL}
                                                    className={`form-control ${errorOf('idTipoAnuncio') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoAnuncio}
                                                    onChange={handleChangeAutoSelect}
                                                    disabled={props.disabled}
                                                    title="Tipo anuncio"
                                                    entidad="TipoAnuncio"
                                                    autoSelect={autoSelect.idTipoAnuncio}
                                                />
                                                <FormError message={errorOf('idTipoAnuncio')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="idTipoPropiedad" required={cartelDefinicion.tipoPropiedadObligatorio}>Tipo
                                                    propiedad</FormLabel>
                                                <InputLista
                                                    name="idTipoPropiedad"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoPropiedad') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoPropiedad}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoPropiedad"
                                                />
                                                <FormError message={errorOf('idTipoPropiedad')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="idCategoriaUbicacion" required={cartelDefinicion.categoriaUbicacionObligatorio}>Categoría
                                                    ubicación</FormLabel>
                                                <InputEntidad
                                                    name="idCategoriaUbicacion"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.CATEGORIA_UBICACION_MODAL}
                                                    className={`form-control ${errorOf('idCategoriaUbicacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.idCategoriaUbicacion}
                                                    onChange={handleChangeAutoSelect}
                                                    disabled={props.disabled}
                                                    title="Categoría ubicación"
                                                    entidad="CategoriaUbicacion"
                                                    autoSelect={autoSelect.idCategoriaUbicacion}
                                                />
                                                <FormError message={errorOf('idCategoriaUbicacion')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="marquesina"
                                                       required={cartelDefinicion.marquesinaObligatorio}>Marquesina</FormLabel>
                                                <InputNumber
                                                    name="marquesina"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('marquesina') ? 'is-invalid' : ''}`}
                                                    value={formValues.marquesina}
                                                    onChange={formHandle}
                                                    precision={0}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('marquesina')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="cantidadPublicidades" required={cartelDefinicion.cantidadPublicidadesObligatorio}>Cantidad
                                                    publicidades</FormLabel>
                                                <InputNumber
                                                    name="cantidadPublicidades"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('cantidadPublicidades') ? 'is-invalid' : ''}`}
                                                    value={formValues.cantidadPublicidades}
                                                    onChange={formHandle}
                                                    precision={0}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('cantidadPublicidades')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-12 col-lg-8">
                                                <FormLabel htmlFor="anuncio" required={cartelDefinicion.anuncioObligatorio}>Anuncio</FormLabel>
                                                <input
                                                    name="anuncio"
                                                    type="text"
                                                    maxLength={250}
                                                    placeholder=""
                                                    className={`form-control ${errorOf('anuncio') ? 'is-invalid' : ''}`}
                                                    value={formValues.anuncio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('anuncio')} />
                                            </div>

                                            <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="fechaInicio" required={cartelDefinicion.fechaInicioObligatorio}>Fecha
                                                    inicio</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaInicio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaInicio') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaInicio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaInicio')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="idTasa" required={cartelDefinicion.tasaObligatorio}>Tasa</FormLabel>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idTasa')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="idSubTasa" required={cartelDefinicion.tasaObligatorio}>Sub tasa</FormLabel>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idSubTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idSubTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    idTasa={formValues.idTasa}
                                                />
                                                <FormError message={errorOf('idSubTasa')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="fechaResolucion" required={cartelDefinicion.fechaResolucionObligatorio}>Fecha
                                                    resolución</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaResolucion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaResolucion') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaResolucion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaResolucion')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="alto" required={cartelDefinicion.altoAnchoObligatorio}>Alto</FormLabel>
                                                <InputNumber
                                                    name="alto"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('alto') ? 'is-invalid' : ''}`}
                                                    value={formValues.alto}
                                                    onChange={formHandle}
                                                    precision={2}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('alto')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="ancho" required={cartelDefinicion.altoAnchoObligatorio}>Ancho</FormLabel>
                                                <InputNumber
                                                    name="ancho"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('ancho') ? 'is-invalid' : ''}`}
                                                    value={formValues.ancho}
                                                    onChange={formHandle}
                                                    precision={2}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('ancho')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="superficie" required={cartelDefinicion.superficieObligatorio}>Superficie</FormLabel>
                                                <InputNumber
                                                    name="superficie"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('superficie') ? 'is-invalid' : ''}`}
                                                    value={formValues.superficie}
                                                    onChange={formHandle}
                                                    precision={2}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('superficie')} />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información catastral" required={cartelDefinicion.catastralObligatorio} open={catastralOpen} onToggle={setCatastralOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12">
                                                <label htmlFor="idCuentaInmueble"
                                                       className="form-label">Inmueble</label>
                                                <InputCuenta
                                                    name="idCuentaInmueble"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idCuentaInmueble}
                                                    onChange={(event) => {
                                                        const cuenta = event.target.row;
                                                        if (cuenta) {
                                                            const idInmueble = parseInt(cuenta.idTributo);
                                                            SetInmuebleData(idInmueble);
                                                        } else {
                                                            ClearInmuebleData();
                                                        }
                                                    }}
                                                    idTipoTributo={10}
                                                    disabled={props.disabled}
                                                />
                                            </div>

                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralCir" className="form-label">Cir.</label>
                                                    <input
                                                        name="catastralCir"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralCir}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralSec" className="form-label">Sec.</label>
                                                    <input
                                                        name="catastralSec"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralSec}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralCod" className="form-label">Código</label>
                                                    <input
                                                        name="catastralCod"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralCod}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralChacra"
                                                           className="form-label">Chacra</label>
                                                    <input
                                                        name="catastralChacra"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralChacra}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralLchacra"
                                                           className="form-label">L.Chacra</label>
                                                    <input
                                                        name="catastralLchacra"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLchacra}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralQuinta"
                                                           className="form-label">Quinta</label>
                                                    <input
                                                        name="catastralQuinta"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralQuinta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralLquinta"
                                                           className="form-label">L.Quinta</label>
                                                    <input
                                                        name="catastralLquinta"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLquinta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralFrac" className="form-label">Frac.</label>
                                                    <input
                                                        name="catastralFrac"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralFrac}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralLfrac"
                                                           className="form-label">L.Frac.</label>
                                                    <input
                                                        name="catastralLfrac"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLfrac}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralManz" className="form-label">Manz.</label>
                                                    <input
                                                        name="catastralManz"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralManz}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralLmanz"
                                                           className="form-label">L.Manz.</label>
                                                    <input
                                                        name="catastralLmanz"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLmanz}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralParc" className="form-label">Parc.</label>
                                                    <input
                                                        name="catastralParc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralParc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralLparc"
                                                           className="form-label">L.Parc.</label>
                                                    <input
                                                        name="catastralLparc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLparc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralSubparc"
                                                           className="form-label">SubParc.</label>
                                                    <input
                                                        name="catastralSubparc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralSubparc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralUfunc"
                                                           className="form-label">U.Func.</label>
                                                    <input
                                                        name="catastralUfunc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralUfunc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-1">
                                                    <label htmlFor="catastralUcomp"
                                                           className="form-label">U.Comp.</label>
                                                    <input
                                                        name="catastralUcomp"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralUcomp}
                                                        onChange={formHandle}
                                                        disabled={props.disabled || formValues.idCuentaInmueble}
                                                        pattern={PATTERNS.onlyNumbersAndLetters}
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <FormError message={errorOf('idCuentaInmueble')} />
                                                </div>

                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Dirección" required={cartelDefinicion.direccionObligatorio} keepMounted={true} open={direccionOpen} onToggle={setDireccionOpen}>
                                        <div className='row form-basic'>
                                            <DireccionForm
                                                ref={direccionFormRef}
                                                data={{
                                                    entity: state.entity.direccion
                                                }}
                                                disabled={props.disabled}
                                                initFormEdit={(state.entity.direccion.id === 0 && state.entity.direccion.latitud === 0 && state.entity.direccion.longitud === 0)}
                                            />
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Declaración jurada" required={cartelDefinicion.declaracionJuradaObligatorio} open={declaracionJuradaOpen} onToggle={setDeclaracionJuradaOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="idOrigenDeclaracionJurada" required={cartelDefinicion.declaracionJuradaObligatorio}>Origen
                                                    DDJJ</FormLabel>
                                                <InputEntidad
                                                        name="idOrigenDeclaracionJurada"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.ORIGEN_DECLARACION_JURADA_MODAL}
                                                        className={`form-control ${errorOf('idOrigenDeclaracionJurada') ? 'is-invalid' : ''}`}
                                                        value={formValues.idOrigenDeclaracionJurada}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Origen DDJJ"
                                                        entidad="OrigenDeclaracionJurada"
                                                    />
                                                <FormError message={errorOf('idOrigenDeclaracionJurada')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                    <FormLabel htmlFor="numeroDDJJ" required={cartelDefinicion.declaracionJuradaObligatorio}>Número
                                                        DDJJ</FormLabel>
                                                    <input
                                                        name="numeroDDJJ"
                                                        type="text"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.NUMERO_DDJJ_MODAL}
                                                        className={`form-control ${errorOf('numeroDDJJ') ? 'is-invalid' : ''}`}
                                                        value={formValues.numeroDDJJ}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('numeroDDJJ')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                    <FormLabel htmlFor="fechaDDJJ" required={cartelDefinicion.declaracionJuradaObligatorio}>Fecha DDJJ</FormLabel>
                                                    <DatePickerCustom
                                                        name="fechaDDJJ"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaDDJJ') ? 'is-invalid' : ''}`}
                                                        value={formValues.fechaDDJJ}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('fechaDDJJ')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6 col-lg-2">
                                                    <FormLabel htmlFor="anioDDJJ" required={cartelDefinicion.declaracionJuradaObligatorio}>Año DDJJ</FormLabel>
                                                    <InputEjercicio
                                                        name="anioDDJJ"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('anioDDJJ') ? 'is-invalid' : ''}`}
                                                        value={formValues.anioDDJJ}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('anioDDJJ')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6 col-lg-2">
                                                    <FormLabel htmlFor="mesDDJJ" required={cartelDefinicion.declaracionJuradaObligatorio}>Mes DDJJ</FormLabel>
                                                    <Select
                                                        name="mesDDJJ"
                                                        className={`form-control ${errorOf('mesDDJJ') ? 'is-invalid' : ''}`}
                                                        value={formValues.mesDDJJ}
                                                        options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                                        emptyOption="Sin selección"
                                                        emptyValue={0}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('mesDDJJ')} />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Baja y bloqueo">
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                <label htmlFor="idMotivoBajaComercio" className="form-label">Motivo
                                                    baja</label>
                                                <InputEntidad
                                                        name="idMotivoBajaComercio"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.MOTIVO_BAJA_COMERCIO_MODAL}
                                                        className="form-control"
                                                        value={formValues.idMotivoBajaComercio}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Motivo baja comercio"
                                                        entidad="MotivoBajaComercio"
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                    <DatePickerCustom
                                                        name="fechaBaja"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaBaja}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-6 col-lg-4">
                                                    <label htmlFor="idBloqueoEmision" className="form-label">Bloqueo
                                                        emisión</label>
                                                    <InputLista
                                                        name="idBloqueoEmision"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.idBloqueoEmision}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        lista="BloqueoEmision"
                                                    />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                            </div>

                            <div className="mb-3 col-12">
                                <Accordion title="Información adicional">
                                    <DataTaggerFormRedux
                                            title="Información adicional de Cartel"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CARTEL_MODAL}
                                            processKey={props.processKey}
                                            entidad="Cartel"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                </Accordion>
                            </div>
                </>)}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (<>
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                                {props.onMovePrevious &&
                                    <button className="btn btn-i" data-dismiss="modal"
                                            onClick={(event) => props.onMovePrevious()}>
                                        <span className="material-symbols-outlined tooltip-container"
                                              title='Anterior'>chevron_left</span>
                                    </button>
                                }
                                {props.onMoveNext &&
                                    <button className="btn btn-i" data-dismiss="modal"
                                            onClick={(event) => props.onMoveNext()}>
                                        <span className="material-symbols-outlined tooltip-container"
                                              title='Siguiente'>chevron_right</span>
                                    </button>
                                }
                </>)}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

CartelModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    onMovePrevious: func,
    onMoveNext: func
};

CartelModal.defaultProps = {
    disabled: false,
    onMovePrevious: null,
    onMoveNext: null
};

export default CartelModal;
